import { customerHelpers } from '@helpers'
import { readStoredUserStatus } from '@/core/auth/user-status.store'

type Customer = Parameters<typeof customerHelpers.getStatus>[0]

// Login identity a logged-in member sends with the type=shop /address call.
// Shared by useTaiwanCheckout (submit) and the cart re-sync so both stay in step.
export const buildTaiwanLoginFields = ({
    auth,
    customer,
    userStatus
}: {
    auth: { token?: string | null; baId?: string | null }
    customer: Customer
    userStatus?: string | null
}) => ({
    ba_status: userStatus ?? readStoredUserStatus() ?? customerHelpers.getStatus(customer) ?? '',
    login_id: auth.baId ?? '',
    login_name: customer.humanName?.['fullName@en'] || customer.humanName?.fullName || '',
    login_name_native: customer.humanName?.fullName || '',
    token: auth.token ?? ''
})
